import { Bitmap, Container, SpineBase, delayedCall, dispatcher, ingenuity, killDelayedCall } from "@quest/base-core";
import { IEvent } from "@quest/base-core";
import { FlowerCollectPanelView } from "./FlowerCollectPanelView";
import { eventDispatchers } from "../../Constants/EventDispatchers";
import { GameParserModel } from "../../Platform/GameParserModel";
import { SoundConstantGame } from "../../Constants/SoundConstantGame";
import { gameConstants } from "../../Constants/gameConstants";
// import { Spine } from "@pixi-spine/all-3.8";
// import { Game } from "@quest/pixi-bridge";
// import { GameParser } from "../../Platform/GameParser";

export class FlowerCollectPanelController {
  protected view: FlowerCollectPanelView;
  constructor(view: FlowerCollectPanelView) {
    this.view = view;
    this.subscribeEvents();
  }
  /**
   * to subscribe feature events
   */
  private subscribeEvents(): void {
    this.unSubscribeEvents();
    dispatcher.on(eventDispatchers.SHOW_COLLECTED_FLOWERS_ON_PANEL, this.showCollectedFlowers, this);
    dispatcher.on(eventDispatchers.COLLECTED_FLOWERS_ON_BET_CHANGE, this.showCollectedFlowersOnNewBet, this);
    dispatcher.on(eventDispatchers.COLLECTED_FLOWERS_ON_BROKEN, this.showCollectedFlowersOnBroken, this);
    dispatcher.on(eventDispatchers.SHOW_PURPLE_FRAME, this.purpleFrameVisibleTween, this);
    dispatcher.on(eventDispatchers.RESET_FLOWER_PANEL_ANIMATION, this.view.resetRunTimeAnimations, this.view);
    // dispatcher.on(eventDispatchers.RESET_MINI_SKULL_ANIMATIONS, this.view.resetMiniSkullAnims, this.view);
    dispatcher.on(eventDispatchers.RESET_FLOWER_PANEL, this.resetFlowerPanel, this);
    dispatcher.on(eventDispatchers.SHOW_PURPLE_FLOWER_CONTAINER_TO_GOLDEN, this.flowerPanelPurpleToGolden, this);
    dispatcher.on(eventDispatchers.EAT_FLOWER_BY_DRAGON, this.eatFlowerByDragon, this);
    dispatcher.on(eventDispatchers.SHOW_MINI_SKULL_ANIMS, this.showMiniSkullAnimations, this);
    dispatcher.on(eventDispatchers.HANDLE_TINT_WILD_SKULLS, this.handleSkullAnimTint, this);
  }
  /**
   * to unsubscribe feature events
   */
  private unSubscribeEvents(): void {
    dispatcher.off(eventDispatchers.SHOW_COLLECTED_FLOWERS_ON_PANEL, this.showCollectedFlowers, this);
    dispatcher.off(eventDispatchers.COLLECTED_FLOWERS_ON_BET_CHANGE, this.showCollectedFlowersOnNewBet, this);
    dispatcher.off(eventDispatchers.COLLECTED_FLOWERS_ON_BROKEN, this.showCollectedFlowersOnBroken, this);
    dispatcher.off(eventDispatchers.SHOW_PURPLE_FRAME, this.purpleFrameVisibleTween, this);
    dispatcher.off(eventDispatchers.RESET_FLOWER_PANEL_ANIMATION, this.view.resetRunTimeAnimations, this.view);
    // dispatcher.off(eventDispatchers.RESET_MINI_SKULL_ANIMATIONS, this.view.resetMiniSkullAnims, this.view);
    dispatcher.off(eventDispatchers.RESET_FLOWER_PANEL, this.resetFlowerPanel, this);
    dispatcher.off(eventDispatchers.SHOW_PURPLE_FLOWER_CONTAINER_TO_GOLDEN, this.flowerPanelPurpleToGolden, this);
    dispatcher.off(eventDispatchers.EAT_FLOWER_BY_DRAGON, this.eatFlowerByDragon, this);
    dispatcher.off(eventDispatchers.SHOW_MINI_SKULL_ANIMS, this.showMiniSkullAnimations, this);
    dispatcher.off(eventDispatchers.HANDLE_TINT_WILD_SKULLS, this.handleSkullAnimTint, this);
  }

  /**
   * function will show currently collected flowers in panel on bet change
   */
  private showCollectedFlowersOnNewBet(): void {
    let flowerData = (ingenuity.parserModel as GameParserModel).getCollectedFlowers();
    flowerData.forEach((currentFlower: number, index: number) => {
      for (let flowerCount = 0; flowerCount < currentFlower; flowerCount++) {
        const flower: Bitmap = this.view.getImageById("filledFlower_" + index + flowerCount);
        if (!flower.visible) {
          flower.visible = true;
        }
        // if ((ingenuity.parserModel as GameParserModel).getWildOnReel().includes(index)) {
        //     this.view.getContainerByID("purpleFrameContainer_" + index).visible = true;
        // }
      }
    });
    (ingenuity.parserModel as GameParserModel).getWildOnReel().forEach((index) => {
      const container = this.view.getContainerByID(`skullAnimCont_${index}`);
      const count = (ingenuity.parserModel as GameParserModel).getCollectedFlowers()[index];
      for (let i = 1; i <= count; i++) {
        const spine = this.view.cloneSpine("skull_meter", i, index);
        spine.json.id = `miniSkullAnim_${index}${i}`;
        container.addChild(spine);
        spine.playAnim("skull_loop", true);
      }
    });
  }
  /**
   * function will show currently collected flowers in panel on broken
   */
  private showCollectedFlowersOnBroken(): void {
    let flowerData = (ingenuity.parserModel as GameParserModel).getPreCollectedFlowers();
    flowerData.forEach((currentFlower: number, index: number) => {
      for (let flowerCount = 0; flowerCount < currentFlower; flowerCount++) {
        const flower: Bitmap = this.view.getImageById("filledFlower_" + index + flowerCount);
        if (!flower.visible) {
          flower.visible = true;
        }
      }
    }, this);
    // let flowerWildData = (ingenuity.parserModel as GameParserModel).getPreWildOnReel()
    // flowerWildData.forEach((reelID: number) => {
    //     this.view.getContainerByID("purpleFrameContainer_" + reelID).visible = true;
    // })
    (ingenuity.parserModel as GameParserModel).getPreWildOnReel().forEach((index) => {
      const container = this.view.getContainerByID(`skullAnimCont_${index}`);
      const count = (ingenuity.parserModel as GameParserModel).getPreCollectedFlowers()[index];
      for (let i = 1; i <= count; i++) {
        const spine = this.view.cloneSpine("skull_meter", i, index);
        spine.json.id = `miniSkullAnim_${index}${i}`;
        container.addChild(spine);
        spine.playAnim("skull_loop", true);
      }
    });
  }
  /**
   * to show collected flowers on the panel
   */
  private showCollectedFlowers(): void {
    (ingenuity.parserModel as GameParserModel).getCollectedFlowers().forEach((currentFlower: number, index: number) => {
      for (let flowerCount = 0; flowerCount < currentFlower; flowerCount++) {
        const flower: Bitmap = this.view.getImageById("filledFlower_" + index + flowerCount);
        if (!flower.visible) {
          flower.visible = true; // show static flower
          this.showCurrentFlowerEffect(currentFlower, index);
          // this.showReelBackGlowEffect(index);
          //   this.showReelFrontGlowEffect(index);
        }
      }
    });
  }
  /**
   * to show flower effect on the panel
   */
  private showCurrentFlowerEffect(currentFlower: number, index: number): void {
    const flowerSpine: SpineBase = this.view.cloneSpine("skull_trail", currentFlower, index);
    let flowerAnimContainer: Container = this.view.getContainerByID("AnimCont_" + index);
    (ingenuity.soundManager as any).playSound(
      SoundConstantGame.SPECIAL_PROGRESS,
      1,
      false,
      gameConstants.SOUND_LIST_PRELOAD
    );
    flowerAnimContainer.addChild(flowerSpine);
    flowerSpine.playAnim("blast");
    flowerSpine.onComplete.addOnce(() => {
      flowerSpine.visible = false;
    });
  }
  /**
   * to show glow effect behind the collect panel
   */
  // private showReelBackGlowEffect(index: number): void {
  // const BackFlowSpine: SpineBase = this.view.cloneSpine();
  // let backAnimContainer: Container = this.view.getContainerByID("AnimBackCont_" + index);
  // backAnimContainer.addChild(BackFlowSpine);
  // BackFlowSpine.playAnim("frame_back_pink_glow");
  // }
  /**
   * to show glow effect on the collect panel
   */
  // private showReelFrontGlowEffect(index: number): void {
  //   let glowSpine: SpineBase;
  //   let glowSpineCont: Container = this.view.getContainerByID("skullAnimCont_" + index);
  //   glowSpine = this.view.cloneSpine("skull_meter");
  //   glowSpineCont.addChild(glowSpine);
  //   glowSpine.visible = true;
  // }

  private showMiniSkullAnimations(): void {
    const presentWildIndices: number[] = (ingenuity.parserModel as GameParserModel).getWildOnReel();
    presentWildIndices.forEach((index) => {
      const container = this.view.getContainerByID(`skullAnimCont_${index}`);
      const count = (ingenuity.parserModel as GameParserModel).getCollectedFlowers()[index];
      const capacity = (ingenuity.parserModel as GameParserModel).getTotalFlowerSpace()[index];
      if (count !== capacity && !ingenuity.configData.isBrokenGame) {
        return;
      }
      for (let i = 1; i <= count; i++) {
        const spine = this.view.cloneSpine("skull_meter", i, index);
        spine.json.id = `miniSkullAnim_${index}${i}`;
        container.addChild(spine);
        spine.playAnim("skull_in", false);
        spine.onComplete.addOnce(() => {
          spine.playAnim("skull_loop", true);
        });
      }
    });
  }
  /**
   * to show purple frame on wild dragon landing
   */
  private purpleFrameVisibleTween(evt: IEvent): void {
    // const purpleFrameContainer = this.view.getContainerByID("purpleFrameContainer_" + (evt.data));
    // purpleFrameContainer.alpha = 0;
    // purpleFrameContainer.visible = true;
    // const prupleFrame = ingenuity.currentGame.add.tween(purpleFrameContainer)
    // prupleFrame.to({ alpha: 1 }, 500, Linear.None, true, 0, 0, false);
    // prupleFrame.onComplete.addOnce(() => {
    //     purpleFrameContainer.alpha = 1;
    //     ingenuity.currentGame.tweens.remove(prupleFrame);
    // })
  }
  /**
   * to hide collected flowers when dragon eats them on next spin call
   */
  private eatFlowerByDragon(evt: IEvent): void {
    this.playSkullOutAnim(evt.data[0], evt.data[1] - 1);
    const flower: Bitmap = this.view.getImageById("filledFlower_" + evt.data[0] + (evt.data[1] - 1));
    delayedCall("eatlowerWithDelay" + evt.data[0] + (evt.data[1] - 1), 150, () => {
      killDelayedCall("eatlowerWithDelay" + evt.data[0] + (evt.data[1] - 1));
      if (flower.visible) {
        flower.visible = false;
      }
    });
  }

  private playSkullOutAnim(index: number, currentFlower: number): void {
    const spine: SpineBase = this.view.getContainerByID(`skullAnimCont_${index}`).children[currentFlower];
    spine.playAnim("skull_out", false);
  }
  /**
   * to convert back flower panel purple to golden
   */
  private flowerPanelPurpleToGolden(): void {
    const purpleWild: number[] = ingenuity.configData.checkForLastFlower;
    purpleWild.forEach((element: number) => {
      this.view.removeCurrentAnimations(this.view.getContainerByID("skullAnimCont_" + [element]));
      // const purpleFrameContainer = this.view.getContainerByID("purpleFrameContainer_" + [element]);
      // purpleFrameContainer.alpha = 1;
      // const prupleFrame = ingenuity.currentGame.add.tween(purpleFrameContainer)
      // prupleFrame.to({ alpha: 0 }, 500, Linear.None, true, 0, 0, false);
      // prupleFrame.onComplete.addOnce(() => {
      //     purpleFrameContainer.alpha = 1;
      //     purpleFrameContainer.visible = false;
      //     ingenuity.currentGame.tweens.remove(prupleFrame);
      // })
    });
  }

  private handleSkullAnimTint(evt: IEvent): void {
        ingenuity.configData.checkForActualWild.forEach((isWild: boolean, index: number) => {
            if (isWild) {
                const container = this.view.getContainerByID(`skullAnimCont_${index}`);
                if (container && container.children.length) {
                    container.children.forEach((child:SpineBase) => {
                      child.tint = evt.data.tint
                    })
                }
            }
        })
    }
  /**
   * to hide purple frame , reset animations , collected flowers
   */
  private resetFlowerPanel(): void {
    this.view.resetFlowers();
    this.view.resetRunTimeAnimations();
    this.view.resetMiniSkullAnims();
    // this.view.resetPurpleFrame();
  }
}
